import React from 'react';
import { ConfirmationPageButton } from './ConfirmationPageButton';
import { IconDownload, IconPrint } from '@snsw/react-component-library/build/Icons/system';
import styled from 'styled-components';

const Container = styled.div`
  margin-right: 0.5em;
  display: flex;
  & > div {
    width: 200px;
  }
  & > div + div {
    margin-left: 1em;
  }
  @media (max-width: 768px) {
    display: block;
    & > div {
      width: 335px;
      button {
        width: 100%;
      }
    }
    & > div + div {
      margin-left: 0;
      margin-top: 1em;
    }
  }
`;

const ConfirmationPageButtons = ({ downloadButtonConfig: dbc, printButtonConfig: pbc }) => {
  const defaultDownloadButtonConfig = {
    visible: true,
    disabled: false,
    label: 'Download',
    variant: 'secondary',
    icon: <IconDownload color={'secondaryBlue'} size={'md'} />,
    className: undefined,
    onClick: () => {},
  };

  const defaultPrintButtonConfig = {
    visible: true,
    disabled: false,
    label: 'Print',
    theme: 'secondary',
    variant: 'secondary',
    icon: <IconPrint color={'secondaryBlue'} size={'sm'} />,
    className: undefined,
    onClick: () => {},
  };

  const downloadButtonConfig = {
    ...defaultDownloadButtonConfig,
    ...dbc,
  };

  const printButtonConfig = {
    ...defaultPrintButtonConfig,
    ...pbc,
  };

  return (
    <Container>
      <div>{downloadButtonConfig.visible && <ConfirmationPageButton {...downloadButtonConfig} />}</div>
      <div>{printButtonConfig.visible && <ConfirmationPageButton {...printButtonConfig} />}</div>
    </Container>
  );
};

export default ConfirmationPageButtons;
